"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  default: () => src_default
});
module.exports = __toCommonJS(src_exports);

// src/coralogix.ts
var EDITOR_CORALOGIX_RUM_SESSION_SAMPLE_RATE = process.env.REACT_APP_CORALOGIX_RUM_SESSION_SAMPLE_RATE ? parseInt(process.env.REACT_APP_CORALOGIX_RUM_SESSION_SAMPLE_RATE) : null;
var WEBSITE_CORALOGIX_RUM_SESSION_SAMPLE_RATE = process.env.NEXT_PUBLIC_CORALOGIX_RUM_SESSION_SAMPLE_RATE ? parseInt(process.env.NEXT_PUBLIC_CORALOGIX_RUM_SESSION_SAMPLE_RATE) : null;
var CORALOGIX_RUM_SESSION_SAMPLE_RATE = EDITOR_CORALOGIX_RUM_SESSION_SAMPLE_RATE || WEBSITE_CORALOGIX_RUM_SESSION_SAMPLE_RATE || 10;
var EDITOR_CORALOGIX_RUM_RECORDING_SAMPLE_RATE = process.env.REACT_APP_CORALOGIX_RUM_RECORDING_SAMPLE_RATE ? parseInt(process.env.REACT_APP_CORALOGIX_RUM_RECORDING_SAMPLE_RATE) : null;
var WEBSITE_CORALOGIX_RUM_RECORDING_SAMPLE_RATE = process.env.NEXT_PUBLIC_CORALOGIX_RUM_RECORDING_SAMPLE_RATE ? parseInt(process.env.NEXT_PUBLIC_CORALOGIX_RUM_RECORDING_SAMPLE_RATE) : null;
var CORALOGIX_RUM_RECORDING_SAMPLE_RATE = EDITOR_CORALOGIX_RUM_RECORDING_SAMPLE_RATE || WEBSITE_CORALOGIX_RUM_RECORDING_SAMPLE_RATE || 10;
var CORALOGIX_AUTHENTICATION_TOKEN = process.env.REACT_APP_CORALOGIX_AUTHENTICATION_TOKEN || process.env.NEXT_PUBLIC_CORALOGIX_AUTHENTICATION_TOKEN || "";
var CORALOGIX_APPLICATION = process.env.REACT_APP_CORALOGIX_APPLICATION || process.env.NEXT_PUBLIC_CORALOGIX_APPLICATION || "kittl";
var CORALOGIX_ENV = process.env.REACT_APP_CORALOGIX_ENV || process.env.NEXT_PUBLIC_CORALOGIX_ENV || process.env.NODE_ENV;
var APP_VERSION = process.env.REACT_APP_PROD_RELEASE_NAME || process.env.NEXT_PUBLIC_PROD_RELEASE_NAME || process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA || process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || "";
var CORALOGIX_RUM_SESSION_RECORDING_ENABLED = process.env.NEXT_PUBLIC_CORALOGIX_RUM_SESSION_RECORDING_ENABLED === "true" || process.env.REACT_APP_CORALOGIX_RUM_SESSION_RECORDING_ENABLED === "true";
var CORALOGIX_RUM_SESSION_RECORDING_CONSOLE_ENABLED = process.env.REACT_APP_CORALOGIX_RUM_SESSION_RECORDING_CONSOLE_ENABLED === "true" || process.env.NEXT_PUBLIC_CORALOGIX_RUM_SESSION_RECORDING_CONSOLE_ENABLED === "true";
var CORALOGIX_RUM_TRACE_HEADER_ENABLED = process.env.REACT_APP_CORALOGIX_RUM_TRACE_HEADER_ENABLED === "true" || process.env.NEXT_PUBLIC_CORALOGIX_RUM_TRACE_HEADER_ENABLED === "true";
var CORALOGIX_RUM_SESSION_RECORDING_CANVAS_ENABLED = process.env.REACT_APP_CORALOGIX_RUM_SESSION_RECORDING_CANVAS_ENABLED === "true";
var CORALOGIX_RUM_TRACK_ON_ERROR_ENABLED = process.env.REACT_APP_CORALOGIX_RUM_TRACK_ON_ERROR_ENABLED === "true" || process.env.NEXT_PUBLIC_CORALOGIX_RUM_TRACK_ON_ERROR_ENABLED === "true";
var CORALOGIX_RUM_MASK_ALL_INPUTS = process.env.REACT_APP_CORALOGIX_RUM_MASK_ALL_INPUTS === "true" || process.env.NEXT_PUBLIC_CORALOGIX_RUM_MASK_ALL_INPUTS === "true";
var EDITOR_CORALOGIX_RUM_SESSION_RECORDING_CANVAS_FPS = process.env.REACT_APP_CORALOGIX_RUM_SESSION_RECORDING_CANVAS_FPS ? parseInt(process.env.REACT_APP_CORALOGIX_RUM_SESSION_RECORDING_CANVAS_FPS) : null;
var WEBSITE_CORALOGIX_RUM_SESSION_RECORDING_CANVAS_FPS = process.env.NEXT_PUBLIC_CORALOGIX_RUM_SESSION_RECORDING_CANVAS_FPS ? parseInt(process.env.NEXT_PUBLIC_CORALOGIX_RUM_SESSION_RECORDING_CANVAS_FPS) : null;
var CORALOGIX_RUM_SESSION_RECORDING_CANVAS_FPS = EDITOR_CORALOGIX_RUM_SESSION_RECORDING_CANVAS_FPS || WEBSITE_CORALOGIX_RUM_SESSION_RECORDING_CANVAS_FPS || 10;
var CORALOGIX_RUM_ENABLED = process.env.REACT_APP_CORALOGIX_RUM_ENABLED === "true" || process.env.NEXT_PUBLIC_CORALOGIX_RUM_ENABLED === "true";
var CORALOGIX_RUM_TRACE_DOMAINS = process.env.REACT_APP_CORALOGIX_RUM_TRACE_DOMAINS || process.env.NEXT_PUBLIC_CORALOGIX_RUM_TRACE_DOMAINS || "";
var CORALOGIX_RUM_TRACE_IGNORED_DOMAINS = process.env.REACT_APP_CORALOGIX_RUM_TRACE_IGNORED_DOMAINS || process.env.NEXT_PUBLIC_CORALOGIX_RUM_TRACE_IGNORED_DOMAINS || "";
var CORALOGIX_RUM_DEBUG = process.env.REACT_APP_CORALOGIX_RUM_DEBUG === "true" || process.env.NEXT_PUBLIC_CORALOGIX_RUM_DEBUG === "true";
var coralogix_default = {
  appVersion: APP_VERSION,
  applicationName: CORALOGIX_APPLICATION,
  authenticationToken: CORALOGIX_AUTHENTICATION_TOKEN,
  debug: CORALOGIX_RUM_DEBUG,
  environment: CORALOGIX_ENV,
  isEnabled: CORALOGIX_RUM_ENABLED,
  maskAllInputs: CORALOGIX_RUM_MASK_ALL_INPUTS,
  sessionRecordingCanvasEnabled: CORALOGIX_RUM_SESSION_RECORDING_CANVAS_ENABLED,
  sessionRecordingCanvasFPS: CORALOGIX_RUM_SESSION_RECORDING_CANVAS_FPS,
  sessionRecordingConsoleEnabled: CORALOGIX_RUM_SESSION_RECORDING_CONSOLE_ENABLED,
  sessionRecordingEnabled: CORALOGIX_RUM_SESSION_RECORDING_ENABLED,
  sessionRecordingSampleRate: CORALOGIX_RUM_RECORDING_SAMPLE_RATE,
  sessionSampleRate: CORALOGIX_RUM_SESSION_SAMPLE_RATE,
  traceDomains: CORALOGIX_RUM_TRACE_DOMAINS,
  traceHeaderEnabled: CORALOGIX_RUM_TRACE_HEADER_ENABLED,
  traceIgnoredDomains: CORALOGIX_RUM_TRACE_IGNORED_DOMAINS,
  trackSessionsWithErrors: CORALOGIX_RUM_TRACK_ON_ERROR_ENABLED
};

// src/index.ts
var isPreviewDeployment = typeof window !== "undefined" && typeof document !== "undefined" && (document?.location?.hostname?.endsWith(".vercel.app") || document?.location?.hostname?.endsWith(".netlify.app"));
var appVersion = process.env.REACT_APP_PROD_RELEASE_NAME || process.env.NEXT_PUBLIC_PROD_RELEASE_NAME || process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA || process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || "";
var isCommitSHA = appVersion.length === 40 && !appVersion.startsWith("release-");
var envVars = {
  apiUrl: process.env.REACT_APP_USER_API_URL || process.env.NEXT_PUBLIC_USER_API_URL || process.env.STORYBOOK_USER_API_URL || "",
  // an empty string is a valid value for Cypress tests,
  cmsApiUrl: process.env.REACT_APP_CMS_API_URL || process.env.STORYBOOK_CMS_API_URL || process.env.NEXT_PUBLIC_CMS_API_URL || "",
  // an empty string is a valid value for Cypress tests,
  // URL of CDN that's in front of image proxy
  imageProxyUrl: process.env.REACT_APP_CONTENT_URL || process.env.NEXT_PUBLIC_CONTENT_URL || process.env.STORYBOOK_CONTENT_URL || "",
  // URL of CDN that supports SEO optimized image names
  seoImageProxyUrl: process.env.REACT_APP_SEO_CONTENT_URL || process.env.NEXT_PUBLIC_SEO_CONTENT_URL || process.env.STORYBOOK_SEO_CONTENT_URL || "",
  cookieDomain: isPreviewDeployment ? void 0 : process.env.REACT_APP_DOMAIN ?? process.env.NEXT_PUBLIC_DOMAIN,
  renderDomain: isPreviewDeployment ? process.env.REACT_APP_RENDER_DOMAIN || process.env.NEXT_PUBLIC_RENDER_DOMAIN || "" : void 0,
  nodeEnv: process.env.NODE_ENV,
  gtmId: process.env.REACT_APP_GTM_ID || process.env.NEXT_PUBLIC_GTM_ID || "",
  mixpanelToken: process.env.REACT_APP_MIXPANEL_TOKEN || process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || "",
  customerIoSiteId: process.env.REACT_APP_CUSTOMERIO_SITE_ID || process.env.NEXT_PUBLIC_CUSTOMERIO_SITE_ID || "",
  coralogix: coralogix_default,
  version: isCommitSHA ? appVersion.slice(0, 7) : appVersion
};
var possiblyUndefinedFields = /* @__PURE__ */ new Set([
  // Allow the SEO image proxy to be undefined (imageProxyUrl will be used instead)
  "seoImageProxyUrl",
  // Allow the cookie domain to be undefined in non-production environments
  "cookieDomain",
  // Render domain can be undefined in non-preview deployments
  "renderDomain"
]);
var env = new Proxy(envVars, {
  get(target, prop) {
    const value = target[prop];
    if (possiblyUndefinedFields.has(prop)) {
      return value;
    }
    if (value === void 0) {
      throw new Error(`Field '${String(prop)}' is not defined in config`);
    }
    return value;
  }
});
var src_default = env;
